
export default function Footer() {
  return (
    <footer className="wrap tac">
      <div className="mt mb p1">2024 &copy; ShowsLike.net</div>
    </footer>
  )
}
